import styled from 'styled-components';

export const Dropdown = styled.div<{ $isOpen: boolean }>`
  position: absolute;
  top: calc(100% + 5px);
  right: 0;
  z-index: 999;
  border-radius: 14px;
  pointer-events: all;
  box-shadow: -4px 4px 15px 0 rgba(18, 20, 25, 0.1),
    5px 5px 15px 0 rgba(18, 20, 25, 0.1);
  opacity: ${({ $isOpen }) => ($isOpen ? 1 : 0)};
  visibility: ${({ $isOpen }) => ($isOpen ? 'visible' : 'hidden')};
  background-color: ${({ theme }) => theme.palette.system.white};
  border: 1px solid ${({ theme }) => theme.palette.secondary.border};
`;
